import { noOp } from 'common/Constants';
import React, { useCallback, useEffect, useState } from 'react';
import { useShowLoginOrSignUpModal } from 'src/auth/modal/useShowLoginOrSignUpModal';
import { Like } from 'src/shared/design-system/ShefSocial/Icons';
import { useCurrentUser } from 'src/shared/hooks/useCurrentUserHook';
import { LikeButtonProps } from '../../types';
import { Button, Wrapper } from './styles';

export const LikeButton: React.FC<LikeButtonProps> = (props) => {
  const { hoverable, id, isLikedByUser, numLikes, onClickLike = noOp } = props;
  const [isLiked, setIsLiked] = useState(!!isLikedByUser);
  const [numberOfLikes, setNumberOfLikes] = useState(numLikes ?? 0);
  const [currentUser, currentUserIsLoading] = useCurrentUser();
  const { show: showLoginOrSignUpModal } = useShowLoginOrSignUpModal();

  const onClick = useCallback(() => {
    if (!isLiked) {
      if (currentUser) {
        setIsLiked(true);
        setNumberOfLikes(numberOfLikes + 1);
        onClickLike(id ?? '');
      } else {
        showLoginOrSignUpModal();
      }
    }
  }, [id, isLiked, numberOfLikes, onClickLike, currentUser, showLoginOrSignUpModal]);

  useEffect(() => {
    setIsLiked(!!isLikedByUser);
    setNumberOfLikes(numLikes ?? 0);
  }, [isLikedByUser, numLikes]);

  if (currentUserIsLoading) return null;

  return (
    <Button onClick={onClick}>
      <Wrapper isLikedByUser={isLiked} hoverable={hoverable}>
        <Like />
        {numberOfLikes}
      </Wrapper>
    </Button>
  );
};
